module.exports = __webpack_public_path__ + "static/wizard_students-744fa8a2491a0c940505be86eca4ae31.png";